module.exports = __webpack_public_path__ + "media/images/game/pages/broker_trust-7972c31cda50547b7530c245b8f7da45.png";